(function() {
    if (!document.querySelectorAll) return;

    const pxElems = Array.from(document.querySelectorAll('.px-fade-anim-2'));
    if (!pxElems.length) return;

    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animateElement(item) {
        if (prefersReduced) {
            const lines = item.querySelectorAll('.px-fade-anim-line');
            lines.forEach(line => line.style.opacity = 1);
            return;
        }

        const tp_fade_offset = 40;
        const tp_duration_value = 0.75;
        const tp_fade_direction = "bottom";
        const tp_onscroll_value = 1;
        const lineOffset = 0.12;
        const tp_delay_value = 0.15;
        const tp_ease_value = "power2.out";

        const lines = item.querySelectorAll('.px-fade-anim-line');
        if (!lines.length) return;

        // Set initial state
        gsap.set(lines, {
            opacity: 0,
            x: (tp_fade_direction === 'left' ? -tp_fade_offset : (tp_fade_direction === 'right' ? tp_fade_offset : 0)),
            y: (tp_fade_direction === 'top' ? -tp_fade_offset : (tp_fade_direction === 'bottom' ? tp_fade_offset : 0))
        });

        const tl = gsap.timeline({ paused: true, defaults: { ease: tp_ease_value } });

        lines.forEach((line, i) => {
            tl.to(line, {
                opacity: 1,
                x: 0,
                y: 0,
                duration: tp_duration_value
            }, tp_delay_value + i * lineOffset);
        });

        if (tp_onscroll_value === 1 && window.ScrollTrigger) {
            ScrollTrigger.create({
                trigger: item,
                start: 'top 60%', // 20% into viewport
                animation: tl,
                once: true
            });
        } else {
            tl.play(); // fallback for no ScrollTrigger
        }
    }

    function runAll() {

        pxElems.forEach(item => {
            animateElement(item);
            try {

            } catch (err) {
                console.error('line animation failed for', item, err);
            }
        });
    }

    function debounce(fn, wait = 180) {
        let id;
        return function() {
            clearTimeout(id);
            id = setTimeout(fn, wait);
        }
    }

    window.addEventListener('load', runAll);
    window.addEventListener('resize', debounce(runAll, 180));
})();